import React, { useEffect, useRef, useState } from "react";
import { Form, Row } from "reactstrap";
import "./index.css";
import { Card, CardBody, CardHeader, Col } from "react-bootstrap";
import DataTable, { TableColumn } from "react-data-table-component";
import StatusBadge from "../../components/StatusBatch";
import {
  useGetCartSearchResultsMutation,
  useGetCartsByStatusMutation,
} from "../../redux/services/cartSearchService";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import ControlledSelectForFiltering from "../../components/ContolledSelectForFiltering";
import ViewButtonComponent from "../../components/ViewButtonComponent";
import BreadCrumbs from "../../components/BreadCrumbs";
import ToggleSwitch from "../../components/ToggleSwitch";
import man from "../../assets/icons/man.PNG";
import ButtonComponentV2 from "../../components/ButtonComponentV2";
import { useSelector, useDispatch } from "react-redux";
import { handaleSelectedCart } from "../../redux/cartSlice";
import { RootState } from "../../redux/store";

import {
  setCartsRowsPerPage,
  setCartStatus,
  setSearchData,
  setSearchResults,
  setCartType,
} from "../../redux/cartSearchSlice";
import ControlledTextField from "../../components/ControlledTextField";
import TableLoadingComponent from "../../components/TableLoadingComponent";
import { CART_STATUS, CART_TYPES } from "../../constants/constans";

export interface CartData {
  id: number;
  imageUrl: string;
  cartId: string;
  displayName: string;
  status: string;
  address: string;
  openingTime: string;
  cartState?: string;
  reasonForBeingOffline?: string;
  location?: { _latitude: number; _longitude: number };
  isFixedLocation?: boolean;
  owner?: {
    id: string;
    userId: string;
  };
  createdAt?: {
    _seconds: number;
    _nanoseconds: number;
  };
  isAssigned?: boolean;
  cartType?: string;
}

export type CartStatusData = {
  cartStatus: { value: string; label: string };
  searchRest: string;
  cartType: { value: string; label: string };
};

const Carts: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showAssigned, setShowAssigned] = useState<boolean>(() => {
    const savedState = localStorage.getItem("showAssigned");
    return savedState ? JSON.parse(savedState) : false;
  });

  const [initialList, setInitialList] = useState<CartData[]>([]);
  const [cartList, setCartList] = useState<CartData[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchTextComform, setSearchTextComform] = useState(false);
  const typingTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isChangeText, setIsChangeText] = useState(false);
  const rowsPerPage = useSelector(
    (state: any) => state.cartSearch.cartsRowsPerPage,
  );
  const [ifReset, setIfReset] = useState(false);

  const searchData = useSelector(
    (state: RootState) => state.cartSearch.searchData,
  );

  const savedCartStatus = useSelector(
    (state: RootState) => state.cartSearch.status,
  );

  const savedCartType = useSelector(
    (state: RootState) => state.cartSearch.cartType,
  );

  const [triggerCartSerachList] = useGetCartSearchResultsMutation();

  const [triggerCartList, { isLoading }] = useGetCartsByStatusMutation();

  const { control, handleSubmit, watch, setValue } = useForm<CartStatusData>({
    defaultValues: {
      cartStatus: savedCartStatus,
      searchRest: searchData,
      cartType: savedCartType || CART_TYPES[0],
    },
  });

  const searchRestWatcher = watch("searchRest");
  const cartStatusWatcher = watch("cartStatus");
  const cartTypeWatcher = watch("cartType");

  const handleChangeRowsPerPage = (newRowsPerPage: number) => {
    dispatch(setCartsRowsPerPage(newRowsPerPage));
  };

  const handleViewCartDetails = (cart: CartData) => {
    dispatch(handaleSelectedCart(cart));
    navigate("/carts/carts-list/view", { state: { cart } });
    setIfReset(true);
  };

  const handleCreateCart = () => {
    navigate("/carts/carts-list/create-cart");
    setIfReset(true);
  };

  const handleSearch = async () => {
    if (isChangeText === true) {
      const obj = {
        params: `query=${searchRestWatcher}`,
      };
      try {
        const response: any = await triggerCartSerachList(obj);
        if (response?.data) {
          setInitialList(response.data);

          const availableRest = response?.data?.hits.filter(
            (item: CartData) => {
              let statusMatch = true;
              let typeMatch = true;

              if (cartStatusWatcher?.label === "All") {
                statusMatch = item.status != null;
              } else {
                statusMatch = item.status === cartStatusWatcher?.label;
              }

              const cartTypeValue = item.cartType?.toLowerCase() || "";

              if (cartTypeWatcher?.value === "all") {
                typeMatch = true; 
              } else if (cartTypeWatcher?.value === "fixed") {
                typeMatch =
                  cartTypeValue === "fixed" || item.isFixedLocation === true;
              } else if (cartTypeWatcher?.value === "delivery") {
                typeMatch = cartTypeValue === "delivery";
              } else if (cartTypeWatcher?.value === "moving") {
                typeMatch = cartTypeValue === "moving" || 
                            (item.isFixedLocation === false && cartTypeValue !== "delivery");
              } else {
                typeMatch = true;
              }

              return statusMatch && typeMatch;
            },
          );
          dispatch(setSearchResults(availableRest));
          setCartList(availableRest);
          if (Array.isArray(response?.data?.hits)) {
            setInitialList(response?.data?.hits);
          } else {
            setInitialList([]);
          }

          setIsChangeText(false);
        } else if (response?.errors) {
          toast.error("Something went wrong...! Please try again.");
        }
      } catch (error) {}
    } else {
      const availableRest = (initialList || []).filter((item: CartData) => {
        let statusMatch = true;
        let typeMatch = true;

        if (cartStatusWatcher?.label === "All") {
          statusMatch = item.status != null;
        } else {
          statusMatch = item.status === cartStatusWatcher?.label;
        }

        const cartTypeValue = item.cartType?.toLowerCase() || "";

        if (cartTypeWatcher?.value === "all") {
          typeMatch = true; 
        } else if (cartTypeWatcher?.value === "fixed") {
          typeMatch =
            cartTypeValue === "fixed" || item.isFixedLocation === true;
        } else if (cartTypeWatcher?.value === "delivery") {
          typeMatch = cartTypeValue === "delivery";
        } else if (cartTypeWatcher?.value === "moving") {
          typeMatch = cartTypeValue === "moving" || 
                      (item.isFixedLocation === false && cartTypeValue !== "delivery");
        } else {
          typeMatch = true;
        }

        return statusMatch && typeMatch;
      });
      setCartList(availableRest);
      dispatch(setSearchResults(availableRest));
    }
  };

  const handleFilterStatusWise = async () => {
    const obj = {
      cartStatus: cartStatusWatcher.label,
    };

    try {
      const response: any = await triggerCartList(obj);
      if (response?.data) {
        const filteredData = response.data.filter((item: CartData) => {
          const cartTypeValue = item.cartType?.toLowerCase() || "";
          
          if (cartTypeWatcher?.value === "all") {
            return true; 
          } else if (cartTypeWatcher?.value === "fixed") {
            return cartTypeValue === "fixed" || item.isFixedLocation === true;
          } else if (cartTypeWatcher?.value === "delivery") {
            return cartTypeValue === "delivery";
          } else if (cartTypeWatcher?.value === "moving") {
            return cartTypeValue === "moving" || 
                   (item.isFixedLocation === false && cartTypeValue !== "delivery");
          }
          return true;
        });

        setCartList(filteredData);
        dispatch(setSearchResults(filteredData));

        if (searchRestWatcher.length) {
          setValue("searchRest", "");
        }
        setIsSearchLoading(false);
      } else if (response?.errors) {
        toast.error("Something went wrong...! Please try again.");
        setIsSearchLoading(false);
      }
    } catch (error) {
      console.log("This is the error", error);
      setIsSearchLoading(false);
    }
  };

  const handaleSearchTextComform = () => {
    if (typingTimer.current) clearTimeout(typingTimer.current);
    setSearchTextComform(false);

    if (searchRestWatcher.length) {
      typingTimer.current = setTimeout(() => {
        setIsSearchLoading(true);
      }, 1500);
      typingTimer.current = setTimeout(() => {
        setSearchTextComform(true);
      }, 3000);
    }

    return () => {
      if (typingTimer.current) {
        clearTimeout(typingTimer.current);
      }
    };
  };

  useEffect(() => {
    if (searchRestWatcher.length < 4 && searchRestWatcher.length !== 0) {
      handleFilterStatusWise();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartStatusWatcher, cartTypeWatcher]); 

  useEffect(() => {
    if (searchRestWatcher.length > 3) {
      handaleSearchTextComform();
    } else if (searchRestWatcher.length === 0 && ifReset) {
      handleFilterStatusWise();
    }
    dispatch(setCartStatus(cartStatusWatcher));
    dispatch(setCartType(cartTypeWatcher));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchRestWatcher, cartStatusWatcher, cartTypeWatcher]);

  useEffect(() => {
    if (searchTextComform) {
      handleSearch();
      setIsSearchLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextComform]);

  useEffect(() => {
    if (!searchData) {
      handleFilterStatusWise();
      setIfReset(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchRestWatcher) {
      setIsChangeText(true);
      setIfReset(true);
    } else {
      setIsChangeText(false);
    }
    dispatch(setSearchData(searchRestWatcher));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchRestWatcher]);

  const handleToggleChange = (_menuId: string, checked: boolean) => {
    setShowAssigned(checked);
    localStorage.setItem("showAssigned", JSON.stringify(checked));
  };

  const filteredCartList = cartList.filter((cart) => {
    const assignmentFilter = showAssigned
      ? (cart?.owner?.id !== null && cart?.owner?.id !== undefined) ||
        cart?.isAssigned
      : !(
          (cart?.owner?.id !== null && cart?.owner?.id !== undefined) ||
          cart?.isAssigned
        );

    return assignmentFilter;
  });

  const onSubmit = async (formData: CartStatusData) => {};

  const columns: TableColumn<CartData>[] = [
    {
      name: <h6 className="fw-bold">Photo</h6>,
      selector: (row) => row.imageUrl,
      cell: (row) => (
        <img
          src={row.imageUrl || man}
          alt={row.displayName}
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "10px",
            margin: "5px",
          }}
          onError={(e) => {
            e.currentTarget.src = man;
          }}
        />
      ),
      sortable: false,
    },
    {
      name: <h6 className="fw-bold">Name</h6>,
      cell: (row) => (
        <div
          className="d-flex gap-2"
          style={{
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          {row.displayName}
        </div>
      ),
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Assign / UnAssign</h6>,
      cell: (row) => (
        <span
          className={
            row?.owner?.id || row?.isAssigned ? "text-success" : "text-danger"
          }
        >
          {row?.owner?.id || row?.isAssigned ? "Assign" : "UnAssign"}
        </span>
      ),
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Cart Type</h6>,
      cell: (row: CartData) => {
        const cartTypeValue = row.cartType?.toLowerCase() || "";
        
        let displayText = "";
        let className = "";

        if (cartTypeValue === "fixed") {
          displayText = "Fixed";
          className = "text-success";
        } else if (cartTypeValue === "delivery") {
          displayText = "Delivery";
          className = "text-primary";
        } else if (cartTypeValue === "moving") {
          displayText = "Moving";
          className = "text-warning";
        } else {
          if (row.isFixedLocation === true) {
            displayText = "Fixed";
            className = "text-success";
          } else if (row.isFixedLocation === false) {
            displayText = "Moving";  
            className = "text-warning";
          } else {
            displayText = "Unknown";
            className = "text-muted";
          }
        }

        return <span className={className}>{displayText}</span>;
      },
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Cart State</h6>,
      cell: (row) => {
        if (row?.status === "Approved") {
          return (
            <>
              {row?.cartState === "offline" ? (
                <div className="text-danger">{row?.reasonForBeingOffline}</div>
              ) : (
                <div className="text-danger">{row?.cartState}</div>
              )}
            </>
          );
        } else if (row?.status === "Pending") {
          return <div className="text-warning">Cart is Pending</div>;
        } else if (row?.status === "Rejected") {
          return <div className="text-danger">Cart is Rejected</div>;
        } else {
          return <div>Unknown Status</div>;
        }
      },
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Status</h6>,
      cell: (row) => <StatusBadge status={row.status} />,
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Action</h6>,
      selector: (row) => "action",
      cell: (row) => (
        <div className="d-flex gap-2">
          <ViewButtonComponent onClick={() => handleViewCartDetails(row)} />
          &nbsp;
        </div>
      ),
      sortable: false,
      right: true,
    },
  ];

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <div>
        <Form
          className="auth-login-form mt-2"
          onSubmit={handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSearch();
            }
          }}
        >
          <Row className="cart-search-top-details-whole-component d-flex justify-content-between align-items-end">
            <Col lg="3" xs="12" className="mb-2 mb-lg-0">
              <h4>Carts</h4>
            </Col>
            <Col
              lg="9"
              sm="12"
              className="d-flex justify-content-end align-items-end"
            >
              <div className="d-flex align-items-end justify-content-between gap-3 flex-wrap-end">
                <div className="d-flex flex-column px-2 align-items-center justify-content-between gap-2">
                  <label className="text-center mb-2">
                    {showAssigned ? "Assigned" : "Unassigned"}
                  </label>
                  <ToggleSwitch
                    menuId=""
                    initialChecked={showAssigned}
                    onChange={handleToggleChange}
                  />
                </div>

                <div className="d-flex flex-column px-1">
                  <ControlledTextField
                    label={
                      <span>
                        Search Cart{" "}
                        {isSearchLoading && (
                          <span className="loading-text-cart">
                            {"  "}
                            Please Wait...
                          </span>
                        )}
                      </span>
                    }
                    inputName="searchRest"
                    inputType="text"
                    control={control}
                    placeholder="Enter at least 4 characters"
                    onBlur={() => setIsSearchActive(false)}
                    className="custom-input"
                  />
                </div>

                <div className="cartStatus-dropDown-component">
                  <ControlledSelectForFiltering
                    label={"Cart Status"}
                    inputName={"cartStatus"}
                    control={control}
                    optionsList={CART_STATUS}
                    className="custom-input"
                  />
                </div>

                {/* Add Cart Type Filter */}
                <div className="cartType-dropDown-component">
                  <ControlledSelectForFiltering
                    label={"Cart Type"}
                    inputName={"cartType"}
                    control={control}
                    optionsList={CART_TYPES}
                    className="custom-input"
                  />
                </div>

                <div>
                  <ButtonComponentV2
                    titel="Create Cart"
                    onClick={handleCreateCart}
                    color="#fff"
                    backgroundColor="#590B21"
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Card>
            <CardHeader className="card-header">
              <div className="d-flex justify-content-between p-2">
                <h5 className="">Carts</h5>
              </div>
              <hr />
            </CardHeader>
            <CardBody>
              {isLoading || isSearchLoading ? (
                <TableLoadingComponent numColumns={5} />
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredCartList}
                  responsive
                  pagination
                  highlightOnHover
                  pointerOnHover
                  paginationPerPage={rowsPerPage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  noDataComponent={<div>No Carts found</div>}
                />
              )}
            </CardBody>
          </Card>
        </Form>
      </div>
    </>
  );
};

export default Carts;